module.exports = __webpack_public_path__ + "profession.f3c88e83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/profile/profession.png
// module id = 2490
// module chunks = 0